import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { RViewWithActionov1gis5vq13n as RViewWithAction } from '../RView.mjs';
import { FutureElement3o36ukl4wk2br as FutureElement } from '../RView.commonHtml.js.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KeyCodes_instancevfnkc2xsbiba as KeyCodes_instance } from '../../models/KeyCode.commonHtml.mjs';
import { vpropka48um9uweps as vprop } from './helpers.commonHtml.mjs';
import { KeyboardHints3coyq4x1rsbe3 as KeyboardHints } from '../../models/data.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function TextArea$content$lambda($this$vprop) {
  // Inline function 'com.lightningkite.kiteui.views.valueString' call
  var tmp = $this$vprop.bb4_1.kb7_1.value;
  var tmp0_elvis_lhs = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null;
  return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
}
function TextArea$content$lambda_0($this$vprop, it) {
  // Inline function 'com.lightningkite.kiteui.views.valueString' call
  $this$vprop.bb4_1.kb7_1.value = it;
  return Unit_instance;
}
var TextAreaClass;
function TextArea() {
  if (TextAreaClass === VOID) {
    class $ extends RViewWithAction() {
      constructor(context) {
        super(context);
        this.vb5_1.zb3_1 = 'div';
        this.vb5_1.jb4_1.v('textarea-container');
        var tmp = this;
        // Inline function 'kotlin.apply' call
        var this_0 = new (FutureElement())();
        this_0.zb3_1 = 'textarea';
        this_0.jb4_1.v('editable');
        this_0.jb4_1.v('kui');
        // Inline function 'com.lightningkite.kiteui.views.resize' call
        this_0.db4_1.hb7_1.resize = 'none';
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var tmp0_safe_receiver = this_0.xb3_1;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          tmp0_safe_receiver.addEventListener('keydown', (it) => {
            if (!(it instanceof KeyboardEvent))
              THROW_CCE();
            if (it.code === KeyCodes_instance.iax() && !it.shiftKey && !(this.mbg_1 == null)) {
              var tmp0_safe_receiver = this.mbg_1;
              if (tmp0_safe_receiver == null)
                null;
              else {
                tmp0_safe_receiver.zbe(this);
              }
              it.preventDefault();
              it.stopImmediatePropagation();
            }
            return Unit_instance;
          });
          tmp_0 = Unit_instance;
        }
        if (tmp_0 == null) {
          // Inline function 'kotlin.run' call
          var tmp_1 = this_0.gb4_1['on' + 'keydown'];
          var old = (!(tmp_1 == null) ? typeof tmp_1 === 'function' : false) ? tmp_1 : null;
          var tmp_2 = 'on' + 'keydown';
          this_0.gb4_1[tmp_2] = (it) => {
            var tmp0_safe_receiver = old;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            if (!(it instanceof KeyboardEvent))
              THROW_CCE();
            if (it.code === KeyCodes_instance.iax() && !it.shiftKey && !(this.mbg_1 == null)) {
              var tmp0_safe_receiver_0 = this.mbg_1;
              if (tmp0_safe_receiver_0 == null)
                null;
              else {
                tmp0_safe_receiver_0.zbe(this);
              }
              it.preventDefault();
              it.stopImmediatePropagation();
            }
            return Unit_instance;
          };
        }
        this.vb5_1.bbu(this_0);
        tmp.rcl_1 = this_0;
        var tmp_3 = this;
        var tmp_4 = TextArea$content$lambda;
        tmp_3.scl_1 = vprop(this.rcl_1, 'input', tmp_4, TextArea$content$lambda_0);
        this.scl_1.vah(() => {
          this.vb5_1.gb9('data-replicated-value', this.scl_1.f2());
          return Unit_instance;
        });
        this.tcl_1 = new (KeyboardHints())();
        this.ucl_1 = '';
      }
      vcl(value) {
        this.ucl_1 = value;
        // Inline function 'com.lightningkite.kiteui.views.placeholder' call
        this.rcl_1.bb4_1.kb7_1.placeholder = value;
      }
      ebs(value) {
        var tmp0 = this.rcl_1.bb4_1;
        // Inline function 'com.lightningkite.kiteui.views.disabled' call
        var value_0 = !value;
        tmp0.kb7_1.disabled = value_0;
      }
      fbs() {
        // Inline function 'com.lightningkite.kiteui.views.disabled' call
        var tmp = this.rcl_1.bb4_1.kb7_1.disabled;
        var tmp0_elvis_lhs = (!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null;
        return !(tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs);
      }
    }
    initMetadataForClass($, 'TextArea');
    TextAreaClass = $;
  }
  return TextAreaClass;
}
//region block: exports
export {
  TextArea as TextArea6va0jt1dj0tc,
};
//endregion

//# sourceMappingURL=TextArea.commonHtml.mjs.map
